import { useNavigate } from 'react-router-dom';
import { Typography } from '../../../../core/components/molecules/Typography';
import { DISCIPLINES_MAP } from '../../constants';
import useFlashcardDiscipline from '../../hooks/use-flashcard-discipline';
import MemoryCard from '../card';
import Carousel from '../carousel';
import DisciplinesFlashCard from '../disciplines-flash-card';
import RadialStatusChart from '../radial-status-chart';
import ReviewDeckCard from '../review-deck-card';
import ScheduledReviews from '../scheduled-reviews';
import DifficultyLevel from '../difficulty-level';
import useRadialStatus from '../../hooks/use-radial-status';
import { useScreenSize } from '../../../../core/hooks/useScreenSize';
import BrainLoadingWrapper from '../../../../core/components/molecules/BrainLoading';

const DeckFlashcards = () => {
  const screenSize = useScreenSize();
  const isMobile = screenSize < 768;
  const navigate = useNavigate();

  const { flashcards, isLoading } = useFlashcardDiscipline();

  const { data: radialStatusChart } = useRadialStatus();

  const items = flashcards
    .filter(({ slug }) => slug)
    .map((discipline) => {
      const bgImage =
        DISCIPLINES_MAP[discipline.slug as keyof typeof DISCIPLINES_MAP]
          .bgImage;
      const gradient =
        DISCIPLINES_MAP[discipline.slug as keyof typeof DISCIPLINES_MAP]
          .gradient;

      return (
        <DisciplinesFlashCard
          key={discipline.uuid}
          title={discipline.name}
          bgImage={bgImage}
          gradient={gradient}
          qtd={discipline?.flashcards?.length || 0}
          onClick={() => {
            navigate(`/memory/flashcards/${discipline.uuid}`);
          }}
        />
      );
    });
  return (
    <div className='mt-9 flex flex-col gap-2'>
      <div className='flex w-full flex-col items-center gap-2'>
        <Typography className='text-h5 font-bold !text-mono-color-darker'>
          Meus <i>Flashcards</i>
        </Typography>
        <div
          className='w-full'
          style={{
            ...(!isMobile && {
              width: 600,
            }),
          }}
        >
          {isLoading ? (
            <div className='flex h-[174px] w-full items-center justify-center '>
              <BrainLoadingWrapper customMessage='Carregando flashcards...' />
            </div>
          ) : (
            <>
              {items.length === 0 ? (
                <MemoryCard>
                  <div className='flex h-[174px]  items-center justify-center'>
                    <Typography className='text-h5 font-bold !text-mono-color-darker'>
                      Nenhum deck cadastrado
                    </Typography>
                  </div>
                </MemoryCard>
              ) : (
                <Carousel
                  items={items}
                  itemsPerSlide={isMobile ? 1 : 3}
                  isMobile={isMobile}
                />
              )}
            </>
          )}
        </div>
        <div className='flex w-full flex-col gap-8 lg:flex-row'>
          <div className='h-full w-full'>
            <ReviewDeckCard />
          </div>
          <div className='w-full'>
            <ScheduledReviews />
            <DifficultyLevel />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeckFlashcards;
